import React from "react";
import { Row, Col } from "react-bootstrap";
import { PenaltyReason } from "../../models/enums/PenaltyReason";

export const penaltyOptions = [
  { value: PenaltyReason.FoulPlay, label: "Foul Play" },
  { value: PenaltyReason.InAtTheSide, label: "In at the side" },
  { value: PenaltyReason.Offside, label: "Offside" },
  { value: PenaltyReason.HandsInTheRuck, label: "Hands in the ruck" },
  { value: PenaltyReason.IllegalTackle, label: "Illegal tackle" },
  { value: PenaltyReason.DoubleMovement, label: "Double Movement" },
  { value: PenaltyReason.PlayingTheNine, label: "Playing The 9" },
  { value: PenaltyReason.TacklerNotReleasing, label: "Tackler Not Releasing" },
  { value: PenaltyReason.OffFeet, label: "Off Feet" },
  { value: PenaltyReason.CollapsingMaul, label: "Collapsing Maul" },
  { value: PenaltyReason.ScrumPenalty, label: "Scrum Penalty" },
  { value: PenaltyReason.NotRollingAway, label: "Not rolling away" },
  { value: PenaltyReason.DeliberateKnockOn, label: "Deliberate knock on" },
  {
    value: PenaltyReason.BallCarrierNotReleasing,
    label: "Ball Carrier Not Releasing",
  },
  { value: PenaltyReason.Dissent, label: "Dissent" },
  { value: PenaltyReason.Obstruction, label: "Obstruction" },
  { value: PenaltyReason.LineoutOffence, label: "Lineout Offence" },
  { value: PenaltyReason.PlayingManInTheAir, label: "Playing man in the air" },
  {
    value: PenaltyReason.DeliberatelyHandlingBallOutOfPlay,
    label: "Deliberately handling ball out of play",
  },
  { value: PenaltyReason.IllegalMaulEntry, label: "Illegal Maul Entry" },
  { value: PenaltyReason.IllegalClearOut, label: "Illegal Clearout" },
  { value: PenaltyReason.RuckAttack, label: "Ruck Attack" },
  { value: PenaltyReason.RuckDefence, label: "Ruck Defence" },
  { value: PenaltyReason.Other, label: "Others" },
];

const PenaltySelector = ({ penalty, handleOptionChange }) => {
  console.log("Rendering PenaltySelector with penalty:", penalty);
  console.log("Penalty options:", handleOptionChange);
  return (
    <div className="col-md-12 text-center checkbox-row">
      <Row
        className="row-cols-1 row-cols-md-3 g-3"
        style={{ marginTop: "2rem", marginLeft: "5px" }}
      >
        {penaltyOptions.map(({ value, label }) => (
          <Col key={value}>
            <div className="text-center checkbox-item">
              <input
                style={{ height: "1em", width: "1em" }}
                className="form-check-input"
                type="radio"
                value={value}
                checked={penalty === value}
                onChange={handleOptionChange}
              />
              <label style={{ marginLeft: "0.5rem" }}>{label}</label>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default PenaltySelector;